/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { CompanyTemperature } from "./CompanyTemperature";
import {
  CompanyTemperatureFromJSON,
  CompanyTemperatureFromJSONTyped,
  CompanyTemperatureToJSON,
  CompanyTemperatureToJSONTyped,
} from "./CompanyTemperature";
import type { LogSalesCallJamieMeetingInput } from "./LogSalesCallJamieMeetingInput";
import {
  LogSalesCallJamieMeetingInputFromJSON,
  LogSalesCallJamieMeetingInputFromJSONTyped,
  LogSalesCallJamieMeetingInputToJSON,
  LogSalesCallJamieMeetingInputToJSONTyped,
} from "./LogSalesCallJamieMeetingInput";
import type { AddLabelsToCompany } from "./AddLabelsToCompany";
import {
  AddLabelsToCompanyFromJSON,
  AddLabelsToCompanyFromJSONTyped,
  AddLabelsToCompanyToJSON,
  AddLabelsToCompanyToJSONTyped,
} from "./AddLabelsToCompany";
import type { CompanyNoteType } from "./CompanyNoteType";
import {
  CompanyNoteTypeFromJSON,
  CompanyNoteTypeFromJSONTyped,
  CompanyNoteTypeToJSON,
  CompanyNoteTypeToJSONTyped,
} from "./CompanyNoteType";

/**
 *
 * @export
 * @interface LogSalesCallInput
 */
export interface LogSalesCallInput {
  /**
   *
   * @type {string}
   * @memberof LogSalesCallInput
   */
  companyNoteId?: string | null;
  /**
   *
   * @type {string}
   * @memberof LogSalesCallInput
   */
  companyId: string;
  /**
   *
   * @type {string}
   * @memberof LogSalesCallInput
   */
  salesContactId?: string | null;
  /**
   *
   * @type {boolean}
   * @memberof LogSalesCallInput
   */
  significant: boolean;
  /**
   *
   * @type {string}
   * @memberof LogSalesCallInput
   */
  recap: string;
  /**
   *
   * @type {CompanyTemperature}
   * @memberof LogSalesCallInput
   */
  temperature?: CompanyTemperature | null;
  /**
   *
   * @type {string}
   * @memberof LogSalesCallInput
   */
  shipmentFrequency?: string | null;
  /**
   *
   * @type {string}
   * @memberof LogSalesCallInput
   */
  shipmentFrequencyNote?: string | null;
  /**
   *
   * @type {boolean}
   * @memberof LogSalesCallInput
   */
  shouldQualify: boolean;
  /**
   *
   * @type {boolean}
   * @memberof LogSalesCallInput
   */
  shouldDisqualify: boolean;
  /**
   *
   * @type {boolean}
   * @memberof LogSalesCallInput
   */
  edited?: boolean | null;
  /**
   *
   * @type {boolean}
   * @memberof LogSalesCallInput
   */
  isEmail?: boolean | null;
  /**
   *
   * @type {string}
   * @memberof LogSalesCallInput
   */
  assignedTo?: string | null;
  /**
   *
   * @type {string}
   * @memberof LogSalesCallInput
   */
  customerSuccessAssignedTo?: string | null;
  /**
   *
   * @type {number}
   * @memberof LogSalesCallInput
   */
  estimatedMonthlyFreightSpend?: number | null;
  /**
   *
   * @type {number}
   * @memberof LogSalesCallInput
   */
  monthlyLtlCaptureEstimate?: number | null;
  /**
   *
   * @type {AddLabelsToCompany}
   * @memberof LogSalesCallInput
   */
  addLabelsToCompany?: AddLabelsToCompany | null;
  /**
   *
   * @type {CompanyNoteType}
   * @memberof LogSalesCallInput
   */
  type?: CompanyNoteType | null;
  /**
   *
   * @type {number}
   * @memberof LogSalesCallInput
   */
  estimatedMonthlyShipments?: number | null;
  /**
   *
   * @type {string}
   * @memberof LogSalesCallInput
   */
  salesContactNotes?: string | null;
  /**
   *
   * @type {LogSalesCallJamieMeetingInput}
   * @memberof LogSalesCallInput
   */
  jamieMeeting?: LogSalesCallJamieMeetingInput | null;
  /**
   *
   * @type {string}
   * @memberof LogSalesCallInput
   */
  disqualificationReason?: string | null;
}

/**
 * Check if a given object implements the LogSalesCallInput interface.
 */
export function instanceOfLogSalesCallInput(
  value: object,
): value is LogSalesCallInput {
  if (!("companyId" in value) || value["companyId"] === undefined) return false;
  if (!("significant" in value) || value["significant"] === undefined)
    return false;
  if (!("recap" in value) || value["recap"] === undefined) return false;
  if (!("shouldQualify" in value) || value["shouldQualify"] === undefined)
    return false;
  if (!("shouldDisqualify" in value) || value["shouldDisqualify"] === undefined)
    return false;
  return true;
}

export function LogSalesCallInputFromJSON(json: any): LogSalesCallInput {
  return LogSalesCallInputFromJSONTyped(json, false);
}

export function LogSalesCallInputFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): LogSalesCallInput {
  if (json == null) {
    return json;
  }
  return {
    companyNoteId:
      json["companyNoteId"] == null ? undefined : json["companyNoteId"],
    companyId: json["companyId"],
    salesContactId:
      json["salesContactId"] == null ? undefined : json["salesContactId"],
    significant: json["significant"],
    recap: json["recap"],
    temperature:
      json["temperature"] == null
        ? undefined
        : CompanyTemperatureFromJSON(json["temperature"]),
    shipmentFrequency:
      json["shipmentFrequency"] == null ? undefined : json["shipmentFrequency"],
    shipmentFrequencyNote:
      json["shipmentFrequencyNote"] == null
        ? undefined
        : json["shipmentFrequencyNote"],
    shouldQualify: json["shouldQualify"],
    shouldDisqualify: json["shouldDisqualify"],
    edited: json["edited"] == null ? undefined : json["edited"],
    isEmail: json["isEmail"] == null ? undefined : json["isEmail"],
    assignedTo: json["assignedTo"] == null ? undefined : json["assignedTo"],
    customerSuccessAssignedTo:
      json["customerSuccessAssignedTo"] == null
        ? undefined
        : json["customerSuccessAssignedTo"],
    estimatedMonthlyFreightSpend:
      json["estimatedMonthlyFreightSpend"] == null
        ? undefined
        : json["estimatedMonthlyFreightSpend"],
    monthlyLtlCaptureEstimate:
      json["monthlyLtlCaptureEstimate"] == null
        ? undefined
        : json["monthlyLtlCaptureEstimate"],
    addLabelsToCompany:
      json["addLabelsToCompany"] == null
        ? undefined
        : AddLabelsToCompanyFromJSON(json["addLabelsToCompany"]),
    type:
      json["type"] == null ? undefined : CompanyNoteTypeFromJSON(json["type"]),
    estimatedMonthlyShipments:
      json["estimatedMonthlyShipments"] == null
        ? undefined
        : json["estimatedMonthlyShipments"],
    salesContactNotes:
      json["salesContactNotes"] == null ? undefined : json["salesContactNotes"],
    jamieMeeting:
      json["jamieMeeting"] == null
        ? undefined
        : LogSalesCallJamieMeetingInputFromJSON(json["jamieMeeting"]),
    disqualificationReason:
      json["disqualificationReason"] == null
        ? undefined
        : json["disqualificationReason"],
  };
}

export function LogSalesCallInputToJSON(json: any): LogSalesCallInput {
  return LogSalesCallInputToJSONTyped(json, false);
}

export function LogSalesCallInputToJSONTyped(
  value?: LogSalesCallInput | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    companyNoteId: value["companyNoteId"],
    companyId: value["companyId"],
    salesContactId: value["salesContactId"],
    significant: value["significant"],
    recap: value["recap"],
    temperature: CompanyTemperatureToJSON(value["temperature"]),
    shipmentFrequency: value["shipmentFrequency"],
    shipmentFrequencyNote: value["shipmentFrequencyNote"],
    shouldQualify: value["shouldQualify"],
    shouldDisqualify: value["shouldDisqualify"],
    edited: value["edited"],
    isEmail: value["isEmail"],
    assignedTo: value["assignedTo"],
    customerSuccessAssignedTo: value["customerSuccessAssignedTo"],
    estimatedMonthlyFreightSpend: value["estimatedMonthlyFreightSpend"],
    monthlyLtlCaptureEstimate: value["monthlyLtlCaptureEstimate"],
    addLabelsToCompany: AddLabelsToCompanyToJSON(value["addLabelsToCompany"]),
    type: CompanyNoteTypeToJSON(value["type"]),
    estimatedMonthlyShipments: value["estimatedMonthlyShipments"],
    salesContactNotes: value["salesContactNotes"],
    jamieMeeting: LogSalesCallJamieMeetingInputToJSON(value["jamieMeeting"]),
    disqualificationReason: value["disqualificationReason"],
  };
}
